export default {"src":"/_next/static/media/ic_play_button.8b936dda.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};